import { SlimUser } from 'shared/administration/models/user'
import { bindOrganizationMembership } from 'shared/api/organizationSession'

import { getRequest } from './common'

export type LoggedInUser = SlimUser & {
  organization: string
  is_org_admin: boolean
  permissions: Record<string, any>
  feature_flags: Record<string, boolean>
}

export interface UserIdentity {
  roles: string[]
  user: LoggedInUser
  web_google_api_key: string
  azure_maps_api_key: string
}

const URL_BASE = '/api/v1/console/'

export function getLoggedInUserIdentity() {
  return getRequest(`${URL_BASE}users/me/`)
}

// Cache user identity in an object with a data property, otherwise it gets optimized out
let userIdentityCache: {
  data: UserIdentity | null
} = {
  data: null,
}

let inFlightRequest: Promise<UserIdentity> | null = null
let generation = 0

export function clearUserIdentityCache() {
  generation += 1
  userIdentityCache.data = null
  inFlightRequest = null
}

export function getLoggedInUserIdentityWithCache(): Promise<UserIdentity> {
  if (userIdentityCache.data) {
    return Promise.resolve(userIdentityCache.data)
  }

  if (inFlightRequest) {
    return inFlightRequest
  }

  const requestGeneration = generation
  inFlightRequest = getLoggedInUserIdentity()
    .then((data) => {
      if (generation === requestGeneration) {
        bindOrganizationMembership(data.user.id)
        userIdentityCache.data = data as UserIdentity
      }
      return data as UserIdentity
    })
    .finally(() => {
      if (generation === requestGeneration) inFlightRequest = null
    })

  return inFlightRequest
}
